import script from "./ImagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePicker.vue?vue&type=script&setup=true&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=24709e52&lang=css"

const __exports__ = script;

export default __exports__